<template>
  <div style="padding: 10px" class="bloc">
    <div v-for="(questionId, id) in questionsId" :key="id">
      <div v-if="questionId == parseInt(questionsId[currentSlide])">
        <BarChart
          style="height: 400px; margin-left: -11px"
          v-if="
            Object.keys(sondage_data_resultats).some(id => id === questionId) &&
              sondage_vue_type_resultats === 'bar'
          "
          :donnees="sondage_data_resultats[questionId]"
          :questionId="questionId"
          :id="id"
        />
        <PieChart
          style="min-height: 410px; margin-left: -11px"
          v-if="
            Object.keys(sondage_data_resultats).some(id => id === questionId) &&
              sondage_vue_type_resultats === 'pie'
          "
          :resultatQueston="sondage_data_resultats[questionId]"
          :questionId="questionId"
          :id="id"
        />
      </div>
      <LibreResultats
        class="test"
        v-if="
          Object.keys(sondage_libre_resultats).some(id => id === questionId) &&
            questionId == parseInt(questionsId[currentSlide])
        "
        :intitule="sondage_libre_resultats[questionId].intitule"
        :reponses="sondage_libre_resultats[questionId]"
      />
    </div>
    <div v-if="sondage_vue_resultats === 'slider'">
      <CarouselButtons :questionsId="questionsId" />
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/resultats/charts/BarChart'
import PieChart from './charts/PieChart'
import LibreResultats from './LibreResultats'
import SectionTitle from './section/SectionTitle'
import CarouselButtons from '@/components/resultats/components/CarouselButtons'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SliderResultats',
  components: {
    BarChart,
    PieChart,
    LibreResultats,
    SectionTitle,
    CarouselButtons
  },
  data () {
    return {
      timer: null,
      classButtonAllResults: ''
    }
  },
  computed: {
    ...mapGetters([
      'type_formulaire',
      'sondage_vue_resultats',
      'sondage_vue_type_resultats',
      'sondage_data_resultats',
      'sondage_libre_resultats',
      'currentSlide'
    ]),
    questionsId: function () {
      let arrayDataChart = Object.keys(this.sondage_data_resultats)
      let arrayDataReponsesLibre = Object.keys(this.sondage_libre_resultats)
      let questionsId = arrayDataChart.concat(arrayDataReponsesLibre)
      questionsId.sort()
      return questionsId
    }
  },
  created () {
    this.$store.commit('UNSET_CHARTS_REFS')
  },
  methods: {

    ...mapMutations({
      vueAll: 'SET_VUE_RESULTATS_ALL'
    }),
    onSwiper (swiper) {
      console.log(swiper)
    },
    onSlideChange () {
      console.log('slide change')
    },
    getWindowWidth (event) {
      let windowWidth = 0
      windowWidth = document.documentElement.clientWidth
      if (windowWidth > 768) {
        this.classButtonAllResults = 'float:right; right:10px; bottom:30px;'
      } else {
        this.classButtonAllResults = ''
      }
    }
  }
}
</script>
<style scoped>
.dot {
  margin: 20px 2px 0px 0;
}
.middleDot {
  vertical-align: sub;
  /* margin: 20px 0px 0px 40px; */
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/SliderResultats.vue